


















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'ui-loading',
})
export default class UiLoadingComponent extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: false }) ok!: boolean;
  @Prop({ default: 'Ошибка' }) errorMessage: string;
  @Prop({ default: 'Операция прошла успешно' }) okMessage: string;
  @Prop({ default: 'Идет загрузка' }) loadingMessage: string;

  mounted() {
    (this.$el as any).parentElement.style.position = 'relative';
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-loading/src/ui-loading.vue